import React from "react";
import MetaManager from "../Layout/MetaManager"; // ✅ Adjust path if needed
import img from "../assets/about.png";
import mission from "../assets/mission.jpg";
import vision from "../assets/vision.jpg";
import affordable from "../assets/affordable.jpg";
import account from "../assets/account.jpg";
import client from "../assets/client.jpg";
import collaboration from "../assets/collaboration.jpg";

// If needed, remove this (for team section, it's not currently used):
// const OurExpertiseTeam = [ ... ];

const About = () => {
  return (
    <>
      {/* ✅ MetaManager for dynamic SEO tags */}
      <MetaManager slug="about" />

      {/* Banner Start */}
      <div className="w-full h-[700px] max-sm:h-[400px] overflow-hidden relative before:block before:absolute before:bg-black before:h-full before:w-full before:top-0 before:left-0 before:z-10 before:opacity-30 max-sm:w-full">
        <img
          src={img}
          className="absolute top-0 left-0 w-full h-full bg-center bg-cover object-cover"
          alt=""
        />
        <div className="relative z-20 max-w-screen-lg mx-auto grid grid-cols-12 h-full items-center">
          <div className="col-span-6 max-sm:col-span-12 max-md:col-span-12 max-lg:col-span-8 max-lg:pl-5">
            <h1 className="text-white font-extrabold text-5xl max-sm:text-2xl max-md:text-3xl max-lg:text-4xl mb-8 max-sm:text-center max-md:text-center">
              About Us
            </h1>
            <p className="text-white text-xl max-sm:text-base max-lg:text-lg leading-9 text-justify font-medium max-sm:text-center max-md:text-center">
              Socioloom isn't just another service provider. We're a
              passionate collective of experts, united by a common goal: to
              empower businesses and startups to thrive. We come from diverse
              backgrounds, each bringing unique skill sets and experiences to
              the table, but we share a unwavering commitment to the core
              values.
            </p>
          </div>
        </div>
      </div>
      {/* Banner End */}

      {/* Mission, Vision, Values Start */}
      <div className="w-full bg-white py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-5xl font-extrabold text-center mb-16" style={{ color: "#07c991a8" }}>
            Who We Are
          </h2>

          {/* Vision */}
          <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
            <div className="flex justify-center">
              <img src={vision} alt="Vision" className="w-90 h-auto" />
            </div>
            <div>
              <h3 className="text-3xl font-bold mb-4" style={{ color: "#07c991a8" }}>
                Our Vision
              </h3>
              <p className="text-lg text-gray-700 leading-8">
                Our Vision at <strong>SocioLoom </strong>to become a globally recognized leader in the digital solutions space, driven by our core strengths in innovation, technology, and customer-centricity. We envision a future where SocioLoom stands at the forefront of digital transformation—empowering businesses across industries to grow, compete, and thrive in the digital age.<br />

                Our goal is to be the trusted partner of choice for organizations seeking high-quality, scalable, and affordable digital services that deliver real value and measurable outcomes. Through continuous innovation, strategic thinking, and a commitment to excellence, we aim to redefine what’s possible in the digital world—making advanced technology accessible to all businesses, regardless of size or budget.<br />

                We aspire to build a future where our digital solutions not only solve problems but also unlock new opportunities for growth, creativity, and long-term success.
              </p>
            </div>
          </div>

          {/* Mission */}
          <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
            <div className="order-2 md:order-1">
              <h3 className="text-3xl font-bold mb-4" style={{ color: "#07c991a8" }}>
                Our Mission
              </h3>
              <p className="text-lg text-gray-700 leading-8">
                At <strong>SocioLoom</strong>,  our mission is to empower businesses of all sizes—from startups to established enterprises—by delivering high-quality, affordable, and tailor-made digital solutions. We are dedicated to helping our clients thrive in the fast-evolving digital landscape through a combination of innovation, integrity, and a customer-centric approach. <br />

                We believe in building long-term partnerships based on trust, transparency, and measurable results. Whether it's through cutting-edge website development, data-driven marketing strategies, branding, or creative design, we aim to equip our clients with the tools and support they need to achieve sustainable growth and digital excellence.<br />

                Our team is passionate about making technology accessible, intuitive, and impactful—ensuring that every solution we deliver not only meets expectations but exceeds them.
              </p>
            </div>
            <div className="order-1 md:order-2 flex justify-center">
              <img src={mission} alt="Mission" className="w-90 h-auto" />
            </div>
          </div>

          {/* Core Values */}
          <div className="text-center">
            <h3 className="text-3xl font-bold mb-10" style={{ color: "#07c991a8" }}>
              Our Core Values
            </h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-left">
              {/* Value Cards */}
              {[
                {
                  img: affordable, title: "Affordability with Integrity", text: `We believe great services
                  shouldn't come at a high cost. We offer transparent pricing
                  without compromising on quality.` },
                { img: account, title: "Accountability & Reliability", text: "We stand by our commitments, deliver on time, and own our results with honesty and professionalism." },
                { img: client, title: "Client-Centric Focus", text: "Your success is our success. We listen, adapt, and tailor our services to meet the unique needs of every client." },
                { img: collaboration, title: "Collaboration", text: "We believe in the power of teamwork — both within our Business and with our clients — to build smarter, stronger digital solutions." },
              ].map((val, idx) => (
                <div key={idx} className="bg-[#f9f9f9] p-6 rounded-lg shadow hover:shadow-lg transition">
                  <img src={val.img} className="w-50 mb-4" alt={val.title} />
                  <h4 className="text-xl font-semibold mb-2 text-black">{val.title}</h4>
                  <p className="text-gray-700 text-sm">{val.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Mission, Vision, Values End */}
    </>
  );
};

export default About;
